import { lazy, Suspense } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import LoadingCircularProgress from '~/components/LoadingCircularProgress';

const DomainNamesPage = lazy(() => import('~/pages/DomainNames'));
const DomainNamesDetailPage = lazy(() => import('~/pages/DomainNames/Detail'));

export const DOMAIN_NAMES_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="flagged" replace />,
  },
  {
    path: ':tab/:listingId?',
    element: (
      <Suspense fallback={<LoadingCircularProgress open />}>
        <DomainNamesPage />
      </Suspense>
    ),
  },
  {
    path: ':tab/detail/:listingId',
    element: (
      <Suspense fallback={<LoadingCircularProgress open />}>
        <DomainNamesDetailPage />
      </Suspense>
    ),
  },
];
